import { lazy } from 'react';
const WisdropPage = lazy(() => import(/* webpackChunkName: "home" */ '.'));
export default WisdropPage;
